export default {
	title: 'Notificación de Advertencia',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminación por Lote',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		deleteSuccess: 'Eliminación exitosa',
		actionSuccess: 'Operación exitosa',
		requiredError: 'El campo obligatorio no puede estar vacío'
	},
	buttons: {
		add: 'Añadir',
		batchDelete: 'Eliminación por Lote',
		edit: 'Editar',
		delete: 'Eliminar',
		pushList: 'Lista de Envío'
	},
	table: {
		warnZone: 'Zona de Advertencia',
		warnSensor: 'Sensor de Advertencia',
		warnContent: 'Contenido de Advertencia',
		warnParameter: 'Parámetro de Advertencia',
		warnTime: 'Tiempo de Advertencia',
		pushTime: 'Tiempo de Envío',
		action: 'Acción'
	},
	form: {
		placeholder: {
			sensor: 'Sensor de Advertencia',
			warnCategory: 'Categoría de Alarma'
		},
		label: {
			gearName: 'Nombre del Engranaje',
			gearBrand: 'Marca del Engranaje',
			bpfo: 'Frecuencia Característica de Falla de Pista Exterior',
			bpfi: 'Frecuencia Característica de Falla de Pista Interior',
			bsf: 'Frecuencia Característica de Falla de Elemento Rodante',
			ftf: 'Frecuencia Característica de Falla de Jaula'
		},
		options: {
			warnCategory: {
				alert: 'Alarma',
				offline: 'Fuera de Línea',
				abnormal: 'Anomalía'
			}
		}
	},
	config: {
		gridLayout: 'Diseño de Cuadrícula'
	},
	dialog: {
		add: 'Añadir',
		update: 'Editar',
		pushList: 'Lista de Envío'
	},
	column: {
		pushType: 'Tipo de Envío',
		recipientCode: 'Código de Identificación del Destinatario',
		pushResult: 'Resultado de Envío'
	}
}
